var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.currentContent,{tag:"component",attrs:{"certified":_vm.componentParams.certified},on:{"goToComponent":_vm.handleComponentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }